import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import PageLayout from '../../components/layout/PageLayout';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const CalculatorHub = () => {
  const navigate = useNavigate();
  

  return (
    <PageLayout
      title="Calculadora 3D"
      subtitle="Escolha o modo de cálculo conforme sua necessidade"
      iconName="Calculator"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Calculadora Profissional (prioritária) */}
        <motion.button
          type="button"
          onClick={() => navigate('/enhanced-cost-calculator')}
          className="calculator-card glassmorphism rounded-2xl p-6 text-left cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25 }}
        >
          <div className="flex items-start justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-secondary/15 rounded-xl flex items-center justify-center">
                <Icon name="Settings" size={22} className="text-secondary" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-foreground">Calculadora Profissional</h2>
                <p className="text-sm text-muted-foreground">Seleção de impressora e filamentos, custos detalhados e avanços</p>
              </div>
            </div>
          </div>
          <div className="mt-6 flex items-center justify-between">
            <div className="text-sm text-muted-foreground">Precisão total com parâmetros avançados</div>
            <Button variant="default" size="xl" iconName="ArrowRight" iconPosition="right">
              Ir para Profissional
            </Button>
          </div>
        </motion.button>

        {/* Cálculo Rápido */}
        <motion.button
          type="button"
          onClick={() => navigate('/quick-calculator')}
          className="calculator-card glassmorphism rounded-2xl p-6 text-left cursor-pointer focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25, delay: 0.05 }}
        >
          <div className="flex items-start justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-primary/15 rounded-xl flex items-center justify-center">
                <Icon name="Zap" size={22} className="text-primary" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-foreground">Cálculo Rápido</h2>
                <p className="text-sm text-muted-foreground">Sem selecionar impressora/filamento, ideal para estimativas imediatas</p>
              </div>
            </div>
          </div>
          <div className="mt-6 flex items-center justify-between">
            <div className="text-sm text-muted-foreground">Parâmetros essenciais, resultado instantâneo</div>
            <Button variant="outline" size="lg" iconName="ArrowRight" iconPosition="right">
              Ir para Rápido
            </Button>
          </div>
        </motion.button>
      </div>
    </PageLayout>
  );
};

export default CalculatorHub;